export const order = {
    requestWork: 'Requested work page',
    order: 'Order',
    from: 'from',
    print: 'Print Home Inspection',
    download: 'Download as PDF',
    homeInspection: 'Home Inspection',
    solutionEstimate: 'Solution Estimate',
    noRequestWorkList: 'Not yet processed',
    printOriginal: 'Print Original and Complete Solution Estimate',
    printReq:'Print Requested Work',
    completeSolution: 'Complete Solution Estimate',

    customer: 'Customer',
    cusHeading: {
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        company: 'Company'
    },

    orderStatus: 'Order Status',
    status: 'Status',
    statusPlace: 'Select a status',
    updateStatus: 'Update Status',

    payment: 'Payment',
    paymentHeading: {
        transId: 'Transaction ID',
        payMethod: 'Payment Method',
        amount: 'Amount',
        date: 'Date'
    },

    productsHeading: {
        id: 'ID',
        image: 'Image',
        name: 'Name',
        price: 'Price',
        quantity: 'Quantity'
    },

    invoice: 'INVOICE',
    invoiceHeading: {
        product: 'PRODUCT',
        price: 'PRICE',
        quantity: 'QUANTITY',
        total: 'TOTAL',
        subTotal: 'SUBTOTAL',
        tax: 'TAX',
        discount: 'DISCOUNT'
    },

    payInfo: 'Please pay within 15 days. Thank you for your business.',
    payNote: 'sample notes'
}
export const orderStatuses = [
    {
        'id': 'pending', // old pending-payment
        'name': 'Pending Payment',
        'color': 'mat-blue-500-bg'
    },
    {
        'id': 'processing',
        'name': 'Processing',
        'color': 'mat-green-800-bg'
    },
    {
        'id': 'on-hold',
        'name': 'On Hold',
        'color': 'mat-orange-800-bg'
    },
    {
        'id': 'completed',
        'name': 'Completed',
        'color': 'mat-purple-500-bg'
    },
    {
        'id': 'cancelled',
        'name': 'Cancelled',
        'color': 'mat-green-800-bg'
    },
    {
        'id': 'refunded',
        'name': 'Refunded',
        'color': 'mat-pink-500-bg'
    },
    {
        'id': 'failed',
        'name': 'Failed',
        'color': 'mat-red-500-bg'
    },
];

export const requestedWorkPage = {

    OriginalAgentSubmission : {
        title : 'Client Info',
        clientName : 'Client Name',
        clientEmail : 'Client Email',
        clientPhone : 'Client Phone',
        clientRole: 'Client Role',
    },
    FinanciallyResponsibleParty : {
        title : 'Financially Responsible Party',
        name : 'Name',
        email : 'Email',
        phone : 'Phone',
        role:'Role',
    },
    Scheduling : {
        title : 'Scheduling',
        requestDate:'Request Date',
        workToBeCompletedBy : 'Work To Be Completed By',
        reinspectionDate : 'Reinspection Date',
        closingDate : 'Closing Date'
    },
    transactionInfo : {
        title : 'Transaction Info',
        closingFirm : 'Closing Firm',
        agent : 'Agent',
        buyerAgent : 'Buyer Agent',
        sellerAgent : 'Seller Agent',
        buyerEmail : 'Email',
        sellerEmail : 'Email',

    },
    homeIns: 'Open Home Inspection',
    approveSolutionEstimatera: 'Open Approve Solution Estimate',
    proSolutionEstimate: 'Open Pro-Solution Estimate',
    preListPictures: 'Open Pre-List Picture Page',
    printScheduling: 'Open print Scheduling Info',
    addWork : 'ADD WORK REQUEST ITEMS',
    cancelWork : 'CANCEL WORK REQUEST  TO ALTER S.E',

    id : "ID",
    description : 'Description',
    picture : 'Picture',
    preListPicture : 'PRE-LIST SPEK-SHEET',
    specificItems : 'Specific Items',
    prePopulatedTitle : 'Specific items auto prepopulated',
    preListPopulated : 'Pre-List items auto prepopulated',
    checkout:{
        clientName: 'Client Name',
        clientEmail: 'Client Email',
        clientPhone: 'Client Phone',
        clienRole: 'Client Role',
        agentName: 'Agent Name',
        agentEmail: 'Agent Email',
        agentTitle : 'Agent Info',
        paymentTitle : 'Payment Info',
        isClosedPay: 'Has your transaction closet yet?',
        closingDate: 'Closing Date',
        beginingDate: 'Earliest date Team can begin work',
        closingAttorney :{
            title: 'Closing Attorney Info',
            name : 'Name',
            phone: 'Phone',
        },
        questions:{
            deadLineDate : 'Absolute deadline for work completed by',
            isPrior: 'work need to be completed prior to closing',
            isOccupied : 'vacant or occupied',
            workResponsibleRole: 'Discuss our progress and completed work with',
            reInspection:'Will you schedule a Re-inspection or Would you prefer completed pictures?',
            whoWorkContact:'Who should we discuss our progress with? ',
            whoPaymentContact:'Who is responsible for payment contact? ',
            whoContact: {
                title: 'Contact Info for access the day of work',
                name: 'Name',
                phone:'Phone',
                email:'Email',
            },
            progressTitle: 'Work Progress Contact Info',
            DatesTitle:'Dates and Home Info',
        },
        paymentInfo:{
            responsibleToPayment : 'Payor Role',
            responsibleToPaymentName : 'Payor Name',
            responsibleToPaymentEmail : 'Payor Email',
            responsibleToPaymentPhone : 'Payor Phone',
        },
        sellerAgentName : 'Seller Agent Name',
        buyerAgentName : 'Buyer Agent Name',
        agentNames: 'Agent And Role Info',
        signature : 'Typed signature from client',
    },
    additionalShare: 'Additional Info',
    additionalWork:'Additional Work',
    additionalInfo : 'Additional Details',
    occupiedOptions:[
        {value: 'vacant',viewValue: 'Vacant'},
        {value: 'occupied_by_tenant',viewValue: 'Occupied by tenant'},
        {value: 'occupied_by_current_owner/seller',viewValue: 'Occupied by current owner/seller'},
        {value: 'occupied_by_new_owner/buyer',viewValue: 'Occupied by new owner/buyer'},
    ],
    scheduleOptions :[
        {value: 'reInspection' , viewValue: 'Reinspection preferred'},
        {value: 'sentPicture', viewValue: 'Prefer completed pictures sent to me'},
    ],
    roleId: {
        currentOwnerAndSeller : '7fbea184-0a71-11ec-8dcc-1722801e9c5c',
        ownerAndBuyer  : '97f57cc8-0a71-11ec-8c9e-d7e9efc7b97c',
        buyerBroker : 'af946e84-0a71-11ec-a1ac-c77b1631d3f6',
        sellerBroker : 'c5573602-0a71-11ec-b562-cba27195b2b8',
    },
}

export const toolTipOfRequestedPage = {
    homeInsReport: "Click to Open home inspetcion report",
    approveSolutionEstimate: "Click to Open approve solution estimate",
    proSolutionEstimate: "Click to Open Pro-Solution Estimate",
    preListPictures: "Click to Open preList Pictures Page",
};


// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/utils/e-commerce/order.ts